<template>
  <div v-if="valorSendoPago > 0" class="mt-3">
    <v-alert v-if="valorSendoPago < valorEmAberto" border="bottom" type="warning">
      O valor sendo pago está abaixo do valor em aberto: se o pagamento for registrado assim, a
      pré-matrícula continuará pendente. Caso a intenção seja dar um desconto, informe o valor no
      campo "Desconto".
    </v-alert>
    <v-alert v-else-if="valorSendoPago > valorEmAberto" border="bottom" type="error">
      {{ valorSendoPago | currency }} está acima do valor em aberto de
      {{ valorEmAberto | currency }}. Caso queira cobrar juros ou multa, informe-os nos campos
      próprios.
    </v-alert>
    <v-alert v-else border="bottom" type="success">
      Tudo certo: a parcela ficará como paga.
    </v-alert>
  </div>
</template>

<script>
/** Os mesmos três avisos da tela de baixa de parcela da mensalidade. */
export default {
  name: "EAlertaDaBaixa",
  props: {
    valorSendoPago: { type: Number, default: 0 },
    valorEmAberto: { type: Number, default: 0 },
  },
};
</script>
